import React, { useState } from 'react';
import { useGetFamilyMemberShareListQuery } from '../../../../../graphql/graphql';
// @ts-ignore
import styles from './ShareChildrenStep1.module.scss';
import Loading from '../../../../BaseModule/Components/Loading';
import { useAppContext } from '../../../../../Services/AppContext';
import { useEffectAsync } from '../../../../../helpers';
import { isAvailableAddAdult } from '../../../Services/FamilyService';
import Button from '../../../../BaseModule/Components/Button/Button/Button';
import NetteApiClient from '../../../../../Services/NetteApiClient';
import { PickedFamilyMember } from './ShareChildrenWrapper';
import Text from '../../../../BaseModule/Components/Text';

interface Props {
	onSelect: (familyMember: PickedFamilyMember) => void;
	onSuccess: () => void;
	childrenId: string;
}

const ShareChildrenStep1: React.FC<Props> = ({ onSelect, onSuccess, childrenId }) => {
	// @ts-ignore
	const { userData, addAdult } = useAppContext();
	const { data, isLoading } = useGetFamilyMemberShareListQuery({
		childId: childrenId
	});
	const [showAddAdult, setShowAddAdult] = useState(false);

	useEffectAsync(async () => {
		const result = await isAvailableAddAdult(userData.id);
		setShowAddAdult(result);
	}, []);

	const handleAddAdult = () => {
		onSuccess();
		NetteApiClient.get(addAdult);
	};

	const canShare = data?.familyMemberShareList?.data && data?.familyMemberShareList?.meta?.count && data?.familyMemberShareList?.meta?.count > 0;

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{canShare ? data?.familyMemberShareList?.data?.map(item => {
				if (item?.user?.profile?.fullName) {
					return (
						<React.Fragment key={item.userId}>
							<Button
								onClick={() =>
									onSelect({
										id: item.userId,
										profileImageUrl: item?.user?.profileImageUrl ?? '',
										fullName: item?.user?.profile?.fullName ?? '',
									})
								}
								title={item.user.profile.fullName}
								icon={item?.user?.profileImageUrl ?? ''}
								subtitle='base.shared.adult'
							/>
						</React.Fragment>
					);
				}
			}) : (
				<div className={styles.wrapper}>
					<Text tx='component.shareChildren.cantShareChildrenAnymore'/>
				</div>
			)}
			{showAddAdult && (
				<Button
					onClick={() => handleAddAdult()}
					icon='/dist/patientV3/icons/addAdult.svg'
					title='base.addAdult'
				/>
			)}
		</div>
	);
};
export default ShareChildrenStep1;
